import { FaChevronRight, FaChevronDown } from "react-icons/fa";
import { Button, Card, Col, Row, Spin, Steps, Tag } from "antd";
import { FLOWS, useJobDetailFlow } from "hook/bailiff/job/flow/useJobDetail";
import React, { useState } from "react";
import { FaRegCheckCircle } from "react-icons/fa";
import { CheckOutlined, LoadingOutlined } from "@ant-design/icons";
//
//component
//redux
//selector
//actions
//utils
//hook
//str

const items = [
  {
    title: (
      <div
        style={{
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        <span>Đoạn văn thứ 1 </span>
        <Spin indicator={<LoadingOutlined spin />} size="small" />
      </div>
    ),
    subTitle: <i>00h:00m:00s - 00h:00m:07s</i>,
    description:
      "Tôi nói mà cô không nghe. tại sao lại cứng đầu như vậy chứ nhỉ. riết rồi không muốn nhắc đến luôn á.",
  },
  {
    title: <div style={{ fontWeight: "bold" }}>Đoạn văn thứ 2</div>,
    subTitle: <i>00h:00m:00s - 00h:00m:07s</i>,
    description:
      "Tôi nói mà cô không nghe. tại sao lại cứng đầu như vậy chứ nhỉ. riết rồi không muốn nhắc đến luôn á.",
  },
  {
    title: <div style={{ fontWeight: "bold" }}>Đoạn văn thứ 3</div>,
    subTitle: <i>00h:00m:00s - 00h:00m:07s</i>,
    description:
      "Tôi nói mà cô không nghe. tại sao lại cứng đầu như vậy chứ nhỉ. riết rồi không muốn nhắc đến luôn á.",
  },
];

const JobSupporter = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useJobDetailFlow();
  const isFlow = flow === FLOWS.SUPPORT;
  // -------------------------- STATE ---------------------------
  const [hide, setHide] = useState(false);
  const icon = !hide ? <FaChevronDown /> : <FaChevronRight />;
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderHeader = () => {
    return (
      <Row style={{ display: "flex", alignItems: "center" }}>
        <Col xl={12} lg={12} md={12} xs={12}>
          <Tag
            style={{
              display: "flex",
              alignItems: "center",
              gap: 5,
              width: "fit-content",
            }}
            color="#1da353"
          >
            <FaRegCheckCircle color="#fff" />
            <span style={{ fontSize: 13 }}>Biên dịch thành công</span>
          </Tag>
        </Col>
        <Col align="right" xl={12} lg={12} md={12} xs={12}>
          <Button
            iconPosition="end"
            type="text"
            size="middle"
            onClick={() => setHide(!hide)}
            icon={<span className="anticon">{icon}</span>}
            style={{ fontWeight: "bold" }}
          >
            Chi tiết
          </Button>
        </Col>
      </Row>
    );
  };

  const renderDialogs = () => {
    if (hide) return null;
    return (
      <Row gutter={[0, 20]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <div style={{ fontWeight: "bold", fontSize: 16 }}>
            Sửa lỗi đoạn văn
          </div>
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <Steps
            status="process"
            progressDot
            size="small"
            items={items}
            direction="vertical"
            current={0}
          />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <Card size="default" title={renderHeader()}>
      <Row gutter={[30, 30]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderDialogs()}
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <i>
            <CheckOutlined style={{ color: "green" }} /> Đã sửa lỗi được 10/20
            đoạn văn
          </i>
        </Col>
      </Row>
    </Card>
  );
};
export default JobSupporter;
